import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-change-teacher-nickname-dialog',
  templateUrl: './change-teacher-nickname.component.html'
})
export class ChangeTeacherNicknameComponent implements OnInit {
  public nickname: string;

  constructor(public dialog: NgbActiveModal) {}

  public ngOnInit(): void {}

  public onCancel(): void {
    this.dialog.dismiss();
  }

  public onSubmit(): void {
    this.dialog.close(this.nickname);
  }
}
